// opervex-frontend/src/Opervex/Dashboard/PowerBI.js
class Employees {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Get Token
  async getToken() {
    return this.#_api.get("/Dashboard/PowerBI/Token");
  }
}

export default Employees;
